import { Navigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { JSX } from 'react';

interface AuthGuardProps {
  children: JSX.Element;
  fallback?: JSX.Element;
}

export default function AuthGuard({ children, fallback }: AuthGuardProps) {
  const { user, initialized, loading } = useAuth();

  if (!initialized || loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background-50">
        <div className="flex items-center gap-3 text-foreground-500">
          <i className="ri-loader-4-line animate-spin text-xl"></i>
          <span className="text-sm">Chargement...</span>
        </div>
      </div>
    );
  }

  if (!user) {
    if (fallback) return fallback;
    return <Navigate to="/auth/login" replace />;
  }

  return children;
}